import { render, staticRenderFns } from "./GGCard.vue?vue&type=template&id=5bcfa013&"
import script from "./GGCard.vue?vue&type=script&lang=js&"
export * from "./GGCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bcfa013')) {
      api.createRecord('5bcfa013', component.options)
    } else {
      api.reload('5bcfa013', component.options)
    }
    module.hot.accept("./GGCard.vue?vue&type=template&id=5bcfa013&", function () {
      api.rerender('5bcfa013', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Global/Card/GGCard.vue"
export default component.exports